import React from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, subMenuHome, subMenuPartners, subMenuProjects, subpodrat1, subpodrat2, whyUs } from '../../../assets/images';


  const newsItems = [
      {
        id: 1,
        imgSrc: subMenuHome,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '15.04.2025',
      },
      {
        id: 2,
        imgSrc: subMenuPartners,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '12.04.2025',
      },
      {
        id: 3,
        imgSrc: subMenuProjects,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '10.04.2025',
      },
      {
          id: 4,
          imgSrc: subMenuHome,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '15.04.2025',
        },
        {
          id: 5,
          imgSrc: subMenuPartners,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '12.04.2025',
        },
        {
          id: 6,
          imgSrc: subMenuProjects,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '10.04.2025',
        },
        {
          id: 7,
          imgSrc: subMenuHome,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '15.04.2025',
        },
        {
          id: 8,
          imgSrc: subMenuPartners,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '12.04.2025',
        },
        {
          id: 9,
          imgSrc: subMenuProjects,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '10.04.2025',
        },
    ];

const SubPodratItems = () => {


      const { t } = useTranslation();

  return (
  <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
          <div className='max-w-containerSm md:max-w-container mx-auto'>




  {/* desktop versiya */}

          <div className='relative md:flex items-center hidden'>
    {/* Sağ div */}
    <div className='w-[52%] ml-auto z-0'>
      <img className='w-full h-full object-cover' src={subpodrat1} />
    </div>
  
    {/* Sol div - sağ divin üstüne binsin */}
    <div className='absolute left-0 z-10 w-[52%]  bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px]'>Subpodratçı Qeydiyyatı Təlimatı</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Subpodratçı olaraq Akond ilə əməkdaşlığa başlamaq üçün əməkdaşlıq siyahmıza düşməyiniz lazımdır. Proseslə bağlı ətraflı məlumat əldə etmək üçün təlimatla tanış olun. 
      </p>
      <a className='group' href='/contact'>
        <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
           <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                                    <img 
                                                                          className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                          src={rightArrow}
                                                                          alt=""
                                                                        />
                                                                        <img
                                                                          className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                          src={rightArrowHover}
                                                                          alt=""
                                                                        />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:flex items-center mt-[100px]  hidden'>
    {/* Sağ div */}
    <div className='absolute right-0 z-10 w-[52%] bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px]'>Yeni Subpodratçı kimi qeydiyyatdan keçin</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Akond şəbəkəsinə yeni subpodratçı kimi qoşulun və innovativ, dinamik komandanın bir hissəsi olun.
      </p>
      <a className='group' href='/contact'>
        <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
           <p className='"transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
                                                    <img 
                                                                          className='w-2 transition-opacity duration-300 group-hover:hidden'
                                                                          src={rightArrow}
                                                                          alt=""
                                                                        />
                                                                        <img
                                                                          className='w-2 transition-opacity duration-300 hidden group-hover:block'
                                                                          src={rightArrowHover}
                                                                          alt=""
                                                                        />
        </div>
      </a>
    </div>
  
    {/* Sol div - sağ divin üstüne binsin */}
    <div className='w-[52%] mr-auto z-0'>
      <img className='w-full h-full object-cover' src={subpodrat2} />
    </div>
  </div>















   {/* mobil versiya */}

  <div className='relative md:hidden items-center'>
    {/* Yukarı div */}
    <div className='ml-auto z-0'>
      <img className='w-full h-full object-cover' src={subpodrat1} />
    </div>
  
    {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
    <div className='absolute top-[130px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[18px]'>Subpodratçı Qeydiyyatı Təlimatı</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Subpodratçı olaraq Akond ilə əməkdaşlığa başlamaq üçün əməkdaşlıq siyahmıza düşməyiniz lazımdır. Proseslə bağlı ətraflı məlumat əldə etmək üçün təlimatla tanış olun. 
      </p>
      <a href='/contact'>
        <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p>Ətraflı</p>
          <img className='w-2' src={rightArrow} />
        </div>
      </a>
    </div>
  </div>
  <div className='relative md:hidden items-center mt-[300px] '>
    {/* Yukarı div */}
    <div className='ml-auto z-0'>
      <img className='w-full h-full object-cover' src={subpodrat2} />
    </div>
  
    {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
    <div className='absolute top-[130px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
      <p className='text-[#1C1C1C] font-medium text-[18px]'>Yeni Subpodratçı kimi qeydiyyatdan keçin</p>
      <p className='mt-3 text-[#1C1C1C]'>
      Akond şəbəkəsinə yeni subpodratçı kimi qoşulun və innovativ, dinamik komandanın bir hissəsi olun.
      </p>
      <a href='/contact'>
        <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
          <p>Ətraflı</p>
          <img className='w-2' src={rightArrow} />
        </div>
      </a>
    </div>
  </div>
  
  
      </div>
      </div>
  )
}

export default SubPodratItems